import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'


let attempts = 0;
const maxAttempts = 5;
const delayMilliseconds = 1000; // 1 second

function checkTokenAndRetry() {
  var token = global.sessionStorage.getItem('accessToken')
  if(!token)
  {
    if (attempts < maxAttempts) {
        
      attempts++;
      setTimeout(checkTokenAndRetry, delayMilliseconds);
    } else {
      console.log("max attempt")
      render()
      // Perform alternative action or error handling here
    }
  } else {
    render()
  }
}


const render = () => {


  const App = require('./App').default

  ReactDOM.render(<App />, document.getElementById('root'))

}

checkTokenAndRetry()

if (process.env.NODE_ENV === 'development' && module.hot) {
  module.hot.accept('./App', render)
}

// Listen for accessToken via postMessage
window.addEventListener('message', event => {
  if (event && event.data && event.data.accessToken) {
    global.sessionStorage.setItem('accessToken', event.data.accessToken)
  }
})